<template>
  <div no-body class="salary-slip project-container">
    <!-- 公司信息头部 -->
    <div class="company-header">
      <div class="logo">
        <img src="@/assets/images/logo/salary_logo.png" alt="WF Logo" />
      </div>
      <div class="company-info">
        <h1>{{ companyInfo.company_name || "永發設計工程有限公司-會計部" }}</h1>
        <p v-if="companyInfo.address">地址： {{ companyInfo.address }}</p>
        <p v-if="companyInfo.phone">電話： {{ companyInfo.phone }}</p>
        <p v-if="companyInfo.website">網址： {{ companyInfo.website }}</p>
        <p v-if="companyInfo.email">電郵： {{ companyInfo.email }}</p>
        <!-- 載入中或錯誤時顯示預設資訊 -->
        <template v-if="!companyInfo.address && !isLoadingCompanyInfo">
          <p>地址： 新界元朗鳳翔路 45-67 號金馬大廈 29 樓地下</p>
          <p>電話： 24798967</p>
          <p>網址： http://wingfatdesign.com</p>
          <p>電郵： sales@wingfatdesign.com</p>
        </template>
      </div>
    </div>

    <h2 class="slip-title">工資單</h2>

    <!-- 员工基本信息表格 -->
    <div class="employee-info">
      <table class="info-table">
        <tr>
          <td>員工証明：</td>
          <td>{{ pdfData.name_cn }}</td>
          <td>計薪方式：</td>
          <td>以工程項目計算</td>
        </tr>
        <tr>
          <td>系統帳號：</td>
          <td>{{ pdfData.name }}</td>
          <td>支付帳號名稱：</td>
          <td>{{ pdfData.bank_account_name }}</td>
        </tr>
        <tr>
          <td>員工編號：</td>
          <td>{{ pdfData.user_number }}</td>
          <td>支付帳號號碼：</td>
          <td>{{ pdfData.bank_account }}</td>
        </tr>
        <tr>
          <td>職位：</td>
          <td>{{ pdfData.position }}</td>
          <td>銀行識別編號：</td>
          <td>
            {{
              pdfData.bank_id &&
              bankOptions &&
              bankOptions.length > 0 &&
              bankOptions.find((bank) => bank.id === pdfData.bank_id).name
            }}
          </td>
        </tr>
        <tr>
          <td>部門：</td>
          <td>{{ pdfData.department }}</td>
          <td>入職日期：</td>
          <td>{{ pdfData.join_date }}</td>
        </tr>
        <tr>
          <td>支付方式：</td>
          <td>
            {{ getSalaryReceiveMethodName() }}
            <span v-if="isChecquePayment() && currentInvoice.check_number">
              <br />支票號碼：{{ currentInvoice.check_number }}
            </span>
          </td>
          <td>支付日期：</td>
          <td>
            {{
              currentInvoice.payment_date &&
              currentInvoice.payment_date.split("T")[0]
            }}
          </td>
        </tr>
        <!-- ... 其他员工信息行 ... -->
      </table>
    </div>
    <!-- 工资明细表格 -->
    <div class="salary-details">
      <table class="salary-table">
        <tr>
          <th colspan="2">工資(本次工資紀錄)</th>
          <th>說明</th>
        </tr>
        <tr>
          <td colspan="2">發票號碼</td>
          <td>{{ currentInvoice.invoice_number || "" }}</td>
        </tr>
        <tr>
          <td colspan="2">施工地址</td>
          <td>{{ currentInvoice.address || "" }}</td>
        </tr>
        <tr>
          <td colspan="2">支付金額</td>
          <td>{{ formatMoney(currentInvoice.actual_salary) || "不適用" }}</td>
        </tr>
        <tr>
          <td colspan="2">支付日期</td>
          <td>
            {{
              (currentInvoice.payment_date &&
                currentInvoice.payment_date.split("T")[0]) ||
              "不適用"
            }}
          </td>
        </tr>
        <tr>
          <td colspan="2">支票號碼</td>
          <td>{{ currentInvoice.check_number || "不適用" }}</td>
        </tr>
        <tr>
          <td colspan="2">預支總金額</td>
          <td>
            {{ formatMoney(currentInvoice.prepayment_amount) || "不適用" }}
          </td>
        </tr>
      </table>

      <!-- 應發工資和實發工資 -->
      <div class="salary-summary">
        <div class="summary-row">
          <span class="summary-label">應發工資：</span>
          <span class="summary-value">{{ calculateGrossSalary() }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">實發工資：</span>
          <span class="summary-value">{{ calculateNetSalary() }}</span>
        </div>
      </div>
    </div>

    <!-- 历史工资记录表格 -->
    <div class="salary-history">
      <div class="d-flex align-items-end justify-content-between">
        <b class="">過往 10 次支付記錄</b>
        <div class="signature"></div>
      </div>
      <table class="history-table">
        <thead>
          <tr>
            <th>支付日期</th>
            <th>施工地址</th>
            <th>發票號碼</th>
            <th>預支金額</th>
            <th>支票號碼</th>
            <th>實發工資</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in historyRecordsWithPadding" :key="index">
            <td>
              {{
                (item.payment_date && item.payment_date.split("T")[0]) || "--"
              }}
            </td>
            <td>
              <span v-if="item.address">{{ item.address }}</span>
              <span v-else></span>
            </td>
            <td>
              <span v-if="item.invoice_number">{{ item.invoice_number }}</span>
              <span v-else></span>
            </td>
            <td class="text-center">
              {{
                item.prepayment_amount
                  ? formatMoney(item.prepayment_amount)
                  : "0"
              }}
            </td>
            <td class="text-center">{{ item.check_number || "--" }}</td>
            <td class="amount">
              {{ item.actual_salary ? formatMoney(item.actual_salary) : "" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer-note">
      本糧單由系統自動生成，貴方可按需要在空白位置簽署以作証明。
    </div>
  </div>
</template>
<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";

import { mapFields } from "vuex-map-fields";
import { formatMoney } from "@/libs/helper.js";
import NoticeToCustomers from "@/views/invoice/invoices-preview/NoticeToCustomers.vue";
import { ref, watch } from "@vue/composition-api";
import axiosIns from "@/libs/axios";

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
      companyInfo: {
        company_name: "",
        address: "",
        phone: "",
        website: "",
        email: "",
      },
      isLoadingCompanyInfo: false,
    };
  },
  methods: {
    formatMoney,
    async fetchCompanyInfo() {
      this.isLoadingCompanyInfo = true;
      try {
        const response = await axiosIns.get(
          "templates/1"
        );
        const template = response.data.template;
        this.companyInfo = {
          company_name: "永發設計工程有限公司-會計部",
          address: template.address || "",
          phone: template.phone || "",
          website: template.website || "",
          email: template.email || "",
        };
      } catch (error) {
        console.error("獲取公司資訊失敗:", error);
        // 保持預設值，不做任何改變
      } finally {
        this.isLoadingCompanyInfo = false;
      }
    },
    changeDate(dateToChange) {
      var newDate = new Date(dateToChange);
      newDate.toLocaleString("default", { month: "long" });
      return (
        newDate.getDate() +
        " " +
        this.month[newDate.getMonth()] +
        " " +
        newDate.getFullYear()
      );
    },
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
    getProject(id) {
      return (
        this.projectOptions &&
        this.projectOptions.length > 0 &&
        this.projectOptions.find((project) => project.id === id)
      );
    },
    calculateGrossSalary() {
      // 對於項目薪資，直接使用 API 回傳的 gross_salary
      const grossSalary = parseFloat(
        this.currentInvoice.gross_salary ||
          this.currentInvoice.total_salary ||
          0
      );
      return this.formatMoney(grossSalary);
    },
    calculateNetSalary() {
      // 對於項目薪資，直接使用 API 回傳的 actual_salary
      const netSalary = parseFloat(
        this.currentInvoice.actual_salary || this.currentInvoice.net_salary || 0
      );
      return this.formatMoney(netSalary);
    },
    // calculateTotalAmount() {
    //   const total = this.pdfData.cost_items.reduce((acc, item) => {
    //     return acc + item.total_salary;
    //   }, 0);
    //   return formatMoney(total);
    // },

    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === "string") {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === "object" && str.content) {
        return typeof str.content === "string"
          ? str.content.replace(/\n/g, "<br>")
          : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === "object" && str.title) {
        return typeof str.title === "string"
          ? str.title.replace(/\n/g, "<br>")
          : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === "number" || typeof str === "boolean") {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str
          .map((item) =>
            typeof item === "string"
              ? item
              : typeof item === "object" && item.content
              ? item.content
              : String(item)
          )
          .join("<br>");
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== "[object Object]" ? stringValue : "";
      } catch (error) {
        console.warn("changeNextLine: 無法處理的資料類型", str);
        return "";
      }
    },
    splitIntoPages() {
      const pageHeight = 500; // 假设页面高度为500px
      let currentPage = [];
      let currentHeight = 0;
      if (this.pdfData.cost_items && this.pdfData.cost_items.length > 0) {
        const counted_array = this.pdfData.cost_items.map((item, index) => {
          return {
            ...item,
            count: index + 1,
          };
        });

        this.pages = counted_array.reduce((acc, item) => {
          const itemHeight = this.calculateItemHeight(item.item_description);
          // + remarkHeight
          if (currentHeight + itemHeight > pageHeight) {
            acc.push(currentPage);
            currentPage = [];
            currentHeight = 0;
          }
          currentPage.push(item);
          currentHeight = Math.round((currentHeight + itemHeight) * 100) / 100;

          return acc;
        }, []);

        if (currentPage.length > 0) {
          this.pages.push(currentPage);
        }

        if (this.pdfData.remark) {
          const remarkHeight = this.calculateItemHeight(this.pdfData.remark);
          const remark_item = {
            is_remark: true,
            id: null,
            item_description: this.pdfData.remark,
            quantity: null,
            unit_price: null,
            amount: null,
          };
          if (remarkHeight + currentHeight > pageHeight) {
            this.pages.push([remark_item]);
          } else {
            this.pages[this.pages.length - 1].push(remark_item);
          }
        }
      } else {
        this.pages = [{ empty: true }];
      }
    },

    calculateItemHeight(item) {
      const baseHeight = 24; // 基础高度
      if (!item) {
        return baseHeight;
      }

      // 创建临时元素来计算实际高度
      const tempDiv = document.createElement("div");
      tempDiv.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: 229px; // 设置与实际显示区域相同的宽度
        font-size: 14px; // 确保字体大小与实际显示一致
        line-height: 1.5; // 设置行高
        white-space: pre-wrap; // 保留换行符并自动换行
      `;

      // 将HTML内容设置到临时元素
      tempDiv.innerHTML = item;
      document.body.appendChild(tempDiv);

      // 获取实际高度
      const actualHeight = tempDiv.offsetHeight;

      // 清理临时元素
      document.body.removeChild(tempDiv);

      // 返回计算后的高度，确保至少有基础高度
      return Math.max(baseHeight, Math.round(actualHeight * 100) / 100);
    },
    //   getTotalAmount() {
    //     var totalAmount = 0;
    //     if (this.pdfData.cost_items) {
    //       this.pdfData.cost_items.forEach((item) => {
    //         totalAmount += item.amount;
    //       });
    //     }
    //     return totalAmount;
    //   },

    // 獲取薪資支付方式名稱
    getSalaryReceiveMethodName() {
      // if (!this.currentInvoice.salary_receive_method) {
      //   return this.pdfData.payment_method || '未指定';
      // }
      console.log("this.currentInvoice", this.currentInvoice);
      return (
        (this.currentInvoice &&
          this.currentInvoice.payment_method &&
          this.currentInvoice.payment_method.name) ||
        ""
      );
    },

    // 判斷是否為支票支付方式
    isChecquePayment() {
      // 檢查 salary_receive_method_id 是否為 1（支票）
      if (this.currentInvoice.salary_receive_method_id === 1) {
        return true;
      }
      // 檢查 salary_receive_method 是否標記為支票
      if (
        this.currentInvoice.salary_receive_method &&
        this.currentInvoice.salary_receive_method.is_cheque
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    NoticeToCustomers,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    bankOptions: {
      type: Array,
      required: true,
    },
    remarkOptions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    "pdfData.cost_items": {
      handler() {
        this.splitIntoPages();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    // 載入公司資訊
    this.fetchCompanyInfo();

    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
    ...mapFields(["controlValue"]),
    currentInvoice() {
      if (
        this.pdfData.salary_records &&
        this.pdfData.salary_records.length > 0
      ) {
        // 尋找標記為當前的記錄
        const currentRecord = this.pdfData.salary_records.find(
          (record) => record.is_current === true
        );

        // 如果沒有找到當前記錄，回退到第一筆記錄
        return currentRecord || this.pdfData.salary_records[0];
      }

      return {};
    },

    /**
     * 確保歷史記錄表格始終顯示10行
     * 如果實際記錄不足10筆，用空白行補充
     */
    historyRecordsWithPadding() {
      const records =
        this.pdfData.salary_records.filter(
          (record) => record.is_current === false
        ) || [];
      const targetLength = 10;

      // 創建空白行模板
      const emptyRecord = {
        payment_date: "",
        invoice_number: "",
        address: "",
        prepayment_amount: "",
        check_number: "",
        actual_salary: "",
      };

      // 處理實際記錄，確保欄位格式正確
      const processedRecords = records.map((record) => ({
        payment_date: record.payment_date || "",
        invoice_number: record.invoice_number || "",
        address: record.address || "",
        prepayment_amount: record.prepayment_amount || 0,
        check_number: record.check_number || "",
        actual_salary: record.actual_salary || record.net_salary || 0,
      }));

      // 如果記錄數量不足10筆，補充空白行
      while (processedRecords.length < targetLength) {
        processedRecords.push({ ...emptyRecord });
      }

      // 只取前10筆記錄
      return processedRecords.slice(0, targetLength);
    },
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);
      console.log("template", template);
      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);
      if (template) {
        info.value.website = template.website;
        info.value.address = template.address;
        info.value.phone = template.phone;
        info.value.fax = template.fax;
        info.value.email = template.email;
        info.value.company_info = template.company_info;
        info.value.bank_info = template.bank_info;
        info.value.logo_url = template.logo_url;
        info.value.stamp_url = stamp ? stamp.image_url || '' : '';
      }
    };
    const getRemark = (id) => {
      let remark =
        props.remarkOptions && props.remarkOptions.find((ele) => ele.id == id);
      return remark && remark.content;
    };

    var init = true;

    watch(
      () => props.pdfData,
      (newVal) => {
        if (newVal && newVal.template_id && init) {
          getInfo(newVal.template_id, newVal.stamp_id);
          init = false;
        }
      }
    );

    return {
      info,
      getInfo,
      getRemark,
    };
  },
};
</script>

<style lang="scss">
.salary-slip.project-container {
  padding: 40px;
  max-width: 100%;
  margin: 0 auto;
  height: 1100px;

  background: #fff;
  * {
    font-family: 新細明體;
  }

  .company-header {
    display: flex;
    // align-items: center;

    .logo {
      width: 120px;
      margin-right: 20px;
      margin-top: -10px;

      img {
        width: 100%;
      }
    }

    .company-info {
      h1 {
        font-size: 18px;
        margin-bottom: 10px;
      }
      p {
        margin: 5px 20px;
        color: #666;
        font-size: 12px;
      }
    }
  }

  .slip-title {
    text-align: right;
    font-size: 24px;
    margin: 0px 0 0;
    border-bottom: 1px solid #000;
  }
  .salary-details {
    margin-bottom: 20px;

    h3 {
      font-size: 16px;
    }

    table {
      th {
        background-color: #f5f5f5;
        text-align: left;
        padding: 5px;
        border: 1px solid #000;

        &:last-child {
          text-align: right;
        }
      }

      td {
        border: 1px solid #000;
        padding: 5px;

        &:last-child {
          text-align: right;
        }
      }
    }
  }

  .salary-summary {
    margin-top: 10px;

    .summary-row {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 5px;

      .summary-label {
        font-weight: bold;
        margin-right: 10px;
      }

      .summary-value {
        width: 100px;
        text-align: right;
      }
    }
  }
  .info-table,
  .salary-table,
  .history-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0px 0 15px;
    border-bottom: 1px solid #000;

    td,
    th {
      padding: 2px;
      // border: 1px solid #ddd;
    }
  }

  .history-table {
    th {
      background-color: #f5f5f5;
      font-weight: bold;
      border: 1px solid #000;
      text-align: center;
      padding: 5px;
    }

    td {
      border: 1px solid #000;
      padding: 5px;
      vertical-align: top;

      &.amount {
        text-align: right;
      }
      &:nth-child(2) {
        width: 240px !important;
        max-width: 240px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .amount {
    text-align: right;
  }

  .footer-note {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: #666;
  }
  .signature {
    width: 200px;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    height: 3px;
    margin-bottom: 4px;
    position: relative;
    &:before {
      content: "簽名:";
      font-size: 12px;
      color: #666;
      position: absolute;
      top: -20px;
      left: -30px;
    }
  }
}
</style>
